var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowExpend = function SvgArrowExpend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    className: "arrowExpend_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M384 512a42.667 42.667 0 0 1-42.667 42.667H145.664l97.835 97.834a42.667 42.667 0 1 1-60.331 60.331L12.501 542.165a42.667 42.667 0 0 1 0-60.33l170.667-170.667a42.667 42.667 0 0 1 60.33 60.33l-97.834 97.835h195.67A42.667 42.667 0 0 1 384 512m256 0a42.667 42.667 0 0 1 42.667-42.667h195.669L780.501 371.5a42.667 42.667 0 0 1 60.374-60.331l170.666 170.667a42.667 42.667 0 0 1 0 60.33L840.875 712.832a42.667 42.667 0 0 1-60.374-60.33l97.835-97.835h-195.67A42.667 42.667 0 0 1 640 512M469.333 768a42.667 42.667 0 1 0 85.334 0V256a42.667 42.667 0 1 0-85.334 0z"
  })));
};
export default SvgArrowExpend;